// extracted by mini-css-extract-plugin
module.exports = {"confirmSessionBg":"JoinConfirmation_confirmSessionBg__3KX4X"};